import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VRadioGroup,{attrs:{"row":"","dense":"","mandatory":"","readonly":_vm.readonly},on:{"change":_vm.onChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.items),function(item){return _c(VRadio,{key:item,attrs:{"label":item,"value":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }